import { render } from "./action-card-table.vue?vue&type=template&id=d1b30afa&scoped=true"
const script = {}

import "./action-card-table.vue?vue&type=style&index=0&id=d1b30afa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.28_typescript@5.9.3__webpack@5.105.4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1b30afa"]])

export default __exports__